import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import css from './Highlights.module.css';

const CheckIcon = () => (
  <svg className={css.icon} viewBox="0 0 36 36" aria-hidden="true">
    <circle cx="18" cy="18" r="16.25" fill="none" stroke="currentColor" strokeWidth="1" />
    <path
      d="M11.5 18.2l4.2 4.1 8.8-9.1"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RatesIcon = () => (
  <svg className={css.icon} viewBox="0 0 36 36" aria-hidden="true">
    <circle cx="18" cy="18" r="16.25" fill="none" stroke="currentColor" strokeWidth="1" />
    <path
      d="M18 10.5v15M21.2 13.2c-.6-.8-1.7-1.3-3.1-1.3-1.9 0-3.2 1-3.2 2.4 0 3.5 6.6 1.8 6.6 5.2 0 1.5-1.4 2.6-3.4 2.6-1.5 0-2.8-.6-3.4-1.6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

const PlaceIcon = () => (
  <svg className={css.icon} viewBox="0 0 36 36" aria-hidden="true">
    <circle cx="18" cy="18" r="16.25" fill="none" stroke="currentColor" strokeWidth="1" />
    <path
      d="M18 25.2s5.2-4.8 5.2-8.6a5.2 5.2 0 1 0-10.4 0c0 3.8 5.2 8.6 5.2 8.6z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <circle cx="18" cy="16.5" r="1.6" fill="none" stroke="currentColor" strokeWidth="1.3" />
  </svg>
);

const items = [
  {
    id: 'credential',
    Icon: CheckIcon,
    titleId: 'LandingHighlights.credentialTitle',
    title: 'Verified providers',
    textId: 'LandingHighlights.credentialText',
    text: 'Credential and background checks',
  },
  {
    id: 'rates',
    Icon: RatesIcon,
    titleId: 'LandingHighlights.ratesTitle',
    title: 'Transparent rates',
    textId: 'LandingHighlights.ratesText',
    text: 'See pricing before you reach out',
  },
  {
    id: 'care',
    Icon: PlaceIcon,
    titleId: 'LandingHighlights.careTitle',
    title: 'In-person and virtual',
    textId: 'LandingHighlights.careText',
    text: 'Choose the format that fits your family',
  },
];

/**
 * Trust points shown beneath the landing hero image.
 */
const Highlights = () => (
  <section className={css.root}>
    <ul className={css.list}>
      {items.map(item => (
        <li key={item.id} className={css.item}>
          <item.Icon />
          <div className={css.copy}>
            <p className={css.title}>
              <FormattedMessage id={item.titleId} defaultMessage={item.title} />
            </p>
            <p className={css.text}>
              <FormattedMessage id={item.textId} defaultMessage={item.text} />
            </p>
          </div>
        </li>
      ))}
    </ul>
  </section>
);

export default Highlights;
